function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import _ from "lodash";
var ResponsiveGridLayout = WidthProvider(Responsive);
var DEFAULT_COLS = {
  lg: 36,
  md: 24,
  sm: 6,
  xs: 2,
  xxs: 1
};
var DEFAULT_BREAKPOINTS = {
  lg: 1200,
  md: 996,
  sm: 768,
  xs: 480,
  xxs: 0
};

var RootObjectFieldTemplate = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(RootObjectFieldTemplate, _React$Component);

  function RootObjectFieldTemplate() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      breakpoint: null,
      row: null
    });

    _defineProperty(_assertThisInitialized(_this), "grid", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "handleLayoutChange", function (props) {
      console.log(props);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBreakpointChange", function (breakpoint, row) {
      if (_this.state.breakpoint === breakpoint) {
        return;
      }

      _this.grid.forceUpdate();

      _this.setState({
        breakpoint: breakpoint,
        row: row,
        loading: true
      });

      process.nextTick(function () {
        _this.setState({
          loading: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderChild", function (childProp) {
      var gridLayout = childProp.content.props.uiSchema.layout;

      var responsiveGridLayout = _.omit(gridLayout, ["sm", "md", "lg"]);

      if (_this.state.breakpoint) {
        var breakpointGridLayout = _.get(gridLayout, _this.state.breakpoint);

        responsiveGridLayout = breakpointGridLayout || responsiveGridLayout;
      }

      return /*#__PURE__*/React.createElement("div", {
        key: childProp.name,
        "data-grid": responsiveGridLayout
      }, childProp.content);
    });

    return _this;
  }

  var _proto = RootObjectFieldTemplate.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.grid.forceUpdate();
    this.setState({
      loading: true
    });
    process.nextTick(function () {
      _this2.setState({
        loading: false
      });
    });
  };

  _proto.renderGridLayout = function renderGridLayout() {
    var _this3 = this;

    var props = this.props;

    var cols = _.get(props, "uiSchema.ui:options.cols");

    var breakpoints = _.get(props, "uiSchema.ui:options.breakpoints");

    return /*#__PURE__*/React.createElement(ResponsiveGridLayout, {
      ref: function ref(grid) {
        _this3.grid = grid;
      },
      layout: "layout",
      breakpoints: _.isObject(breakpoints) ? breakpoints : DEFAULT_BREAKPOINTS,
      cols: _.isObject(cols) ? cols : DEFAULT_COLS,
      autoSize: true,
      onBreakpointChange: this.handleBreakpointChange,
      onLayoutChange: this.handleLayoutChange,
      rowHeight: 150,
      isResizable: false,
      isDraggable: false
    }, props.properties.map(function (childProp) {
      return _this3.renderChild(childProp);
    }));
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: this.props.uiSchema.$header
      }
    }), !this.state.loading && this.renderGridLayout());
  };

  return RootObjectFieldTemplate;
}(React.Component);

export default RootObjectFieldTemplate;